import { useContext } from 'react';
import { getAuthToken } from 'services/apiUtils';
import { AuthContext } from 'services/auth/AuthContext';
import { loginService, logoutService } from 'services/auth/ServicioAuth';

export const useAuth = () => {
  const { state, dispatch } = useContext(AuthContext);

  const login = async (
    email: string,
    password: string,
    setError: (message: string) => void,
    setLoading: (state: boolean) => void
  ) => {
    try {
      setLoading(true);
      const result = await loginService({ Email: email, Password: password }, setError, setLoading);
      if (result) {
        dispatch({
          type: 'LOGIN_SUCCESS',
          payload: { usuario: result.usuario, token: result.token },
        });
      }
    } catch (error) {
      setError('Error durante el inicio de sesión');
    } finally {
      setLoading(false);
    }
  };

  const logout = async (setError: (message: string) => void, setLoading: (state: boolean) => void) => {
    const token = getAuthToken();
    setLoading(true);
    if (token) {
      try {
        await logoutService(setError, setLoading); // Elimina el token del localStorage
        dispatch({ type: 'LOGOUT' }); // Limpia el estado de Redux
      } catch (error) {
        setError('Error durante el cierre de sesión');
      } finally {
        setLoading(false);
      }
    } else {
      setError('Tu sesión ha expirado');
      dispatch({ type: 'LOGOUT' });
    }
  };

  return {
    token: state.token,
    login,
    logout,
  };
};
